const TOKEN_KEY = "vms_access_token";
const USER_KEY = "vms_user";

export const getVmsToken = () => sessionStorage.getItem(TOKEN_KEY) || "";

export const setVmsSession = (token, user) => {
  const normalizedUser = {
    ...(user || {}),
    firstTimeLogin: Boolean(user?.firstTimeLogin ?? user?.first_time_login),
  };
  sessionStorage.setItem(TOKEN_KEY, token || "");
  sessionStorage.setItem(USER_KEY, JSON.stringify(normalizedUser));
};

export const clearVmsSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

export const getVmsUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem(USER_KEY) || "{}");
  } catch {
    return {};
  }
};

export const isVmsAuthenticated = () => Boolean(getVmsToken());

export const getVmsUserRole = () => getVmsUser()?.role || "";
export const isVmsFirstTimeLogin = () => {
  const user = getVmsUser();
  return Boolean(user?.firstTimeLogin ?? user?.first_time_login);
};

export const updateVmsUser = (patch = {}) => {
  const current = getVmsUser();
  sessionStorage.setItem(USER_KEY, JSON.stringify({ ...current, ...patch }));
};

export const isVmsGeneralAdmin = () => getVmsUserRole() === "general_admin";

export const isVmsOfficeUser = () => getVmsUserRole() === "office_user";
